
import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-message-details',
  standalone: true,
  imports: [CommonModule, InfiniteScrollModule,
CommonSkeletonComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './message-details.component.html',
  styleUrls: ['./message-details.component.scss']
})
export class MessageDetailsComponent extends FormValidation implements OnChanges {
  url = AppSettings.ServerUrl + "download/";
  @Input()
  MessageDetails: any;
  @Input()
  GroupType: any;
  @Input()
  selectedMenu: any;
  @Input()
  SelectedContact: any;
  @Input()
  Jobandcandidatedetails: any;
  @Input() nodatafound: boolean; // Receive loading state
  @Input() isLoading: boolean; // Receive loading state
  @Output() viewProfile = new EventEmitter<any>();

  onViewProfile() {
    this.viewProfile.emit(this.SelectedContact);
  }
  prevAfterkey = null;
  stopScroll: boolean = false
  loadApicall:boolean=false
  loadingMore: boolean = false // pagination (scroll) loading — shown as a skeleton, not the util spinner
  @ViewChild('entityContainer') entityContainer: ElementRef; // members scroll container (for auto-fill)

  connectionlistuserdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor(
    private JobServicecolor: JobService, private api: ApiService, private util: UtilService, private aroute: ActivatedRoute

  ) {
    super();



  }
  resetConnectionList() {
    this.connectionlistuserdata.next([]); // Empty the BehaviorSubject
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.Jobandcandidatedetails) {
      const prev = changes.Jobandcandidatedetails.previousValue;
      const curr = changes.Jobandcandidatedetails.currentValue;

      if (!prev || JSON.stringify(prev) !== JSON.stringify(curr)) {
        if (this.isAllowedGroup()) {
         this.loadApicall=true;
          this.contact.searchAfterKey = null;
          // Reset the end-of-list state for the new group so the indicator only
          // appears once THIS group's members paginate to the last (short) page.
          this.stopScroll = false;
          this.prevAfterkey = undefined;
          this.connectionlistuserdata.next([]);
          this.getGroupMembers();
        }
      }
    }

    if(changes.selectedMenu && changes.selectedMenu.currentValue != changes.selectedMenu.previousValue) {
      this.selectedMenu = changes.selectedMenu.currentValue
    }
    // console.log(changes.isLoading, "loading")
    // console.log(changes.nodatafound, "nodatafound")
    // console.log(changes.Jobandcandidatedetails, "Jobandcandidatedetails")
    // console.log(changes.SelectedContact, "SelectedContact")
    // console.log(changes.selectedMenu, "selectedMenu")
    // console.log(changes.GroupType, "GroupType")
    // console.log(changes.MessageDetails, "MessageDetails")
  }



  ngOnInit() {

  }

  isAllowed(): boolean {
    const restrictedTypes: Array<string> = ['JOB', 'CANDIDATE', 'USER', 'SUPPORT'];
    return !restrictedTypes.some(ele=>ele === this.GroupType);
  }

  isAllowedGroup(): boolean {
    if(this.SelectedContact.status === 'INACTIVE' && this.GroupType === 'GROUP') {
      return false;
    }
    const restrictedTypes = ['JOB', 'CANDIDATE', 'USER', 'SUPPORT'];
    const groupTypeValue = this.GroupType || '';
    const selectedMenuValue = this.selectedMenu || '';
    return !(restrictedTypes.includes(groupTypeValue) || restrictedTypes.includes(selectedMenuValue));
  }

  isAllowedUsers(): boolean {
    const restrictedTypes = ['JOB', 'CANDIDATE', 'USER'];
    return (this.GroupType || this.selectedMenu) && // Ensure values are defined
      (restrictedTypes.includes(this.GroupType) ||
        restrictedTypes.includes(this.selectedMenu));
  }

  // Standalone person chat (not a JOB/CANDIDATE chat). Used to show the full
  // contact profile (stats / contact info / quick actions) ONLY for USER chats;
  // JOB/CANDIDATE chats show just the compact avatar+name+role header.
  isUserChat(): boolean {
    return this.GroupType === 'USER' || this.selectedMenu === 'USER';
  }

  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  onScrollDown() {
    if (!this.stopScroll && this.prevAfterkey !== undefined && JSON.stringify(this.contact.searchAfterKey) !== JSON.stringify(this.prevAfterkey)) {
      this.contact.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
      this.loadingMore = true; // show the bottom skeleton while the next page loads
      this.getGroupMembers();
    }
  }

  // If the loaded members don't overflow their container (e.g. zoomed out or a
  // tall screen), the (scrolled) event can never fire and the remaining pages
  // would never load. Auto-load the next page until the list overflows (a real
  // scrollbar appears) or we reach the last page (stopScroll).
  ensureFilled() {
    if (this.stopScroll) { return; }
    const el = this.entityContainer && this.entityContainer.nativeElement;
    if (!el) { return; }
    if (el.scrollHeight <= el.clientHeight) {
      this.onScrollDown();
    }
  }

  contact = {
    createdBy: null,
    groupId: null,
    groupType: null,
    searchAfterKey: null,
    limit: 10
  };
  previousSearchAfterKey: any = null;

  ngOnDestroy() {
    this.loadApicall = false; // Reset when component is destroyed
  }

  getGroupMembers() {
    if (!this.SelectedContact || Object.keys(this.SelectedContact).length === 0) {
      this.loadApicall=false;
      return;
    }
    const groupType = this.aroute.snapshot.queryParamMap.get('type') || this.SelectedContact.groupType;
    Object.assign(this.contact, {
      groupId: this.SelectedContact.groupId,
      createdBy: this.SelectedContact.createdBy,
      groupType: groupType,
    });
    // No util spinner here — loading is shown via skeletons (initial: loadApicall,
    // scroll pagination: loadingMore).
    this.api.messagePageService('POST', "message/group/getGroupMembers", this.contact).subscribe(res => {
      this.loadApicall=false;
      this.loadingMore=false;
      let data = res?.data?.groupMembers || []; // Ensure it's an array
      if (data != null) {
        const resData = data;
        const afterKey = res.data && res.data.searchAfterKey;

        // Last page reached when the API returns fewer rows than the page limit
        // (a full page means there may still be more; a short page is the end).
        if (!resData || resData.length < this.contact.limit) {
          this.stopScroll = true;
        }
        this.prevAfterkey = afterKey;
        if (Array.isArray(data) && data.length > 0) {
          const existingData = this.connectionlistuserdata.getValue();
          this.connectionlistuserdata.next([...existingData, ...data]); // Append new users
        }

        // After the new rows render, keep loading until the list overflows its
        // container (so a scrollbar exists) or we hit the last page.
        setTimeout(() => this.ensureFilled(), 0);
      }
    }, err => { this.loadApicall = false; this.loadingMore = false; });

  }

  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  // Member subtitle: show the title, else fall back to the converted userType
  // (same fallback the New Private/Group Chat sliders use).
  getMemberSubtitle(user: any): string {
    if (!user) { return ''; }
    const title = user.title && String(user.title).trim();
    if (title) { return title; }
    return this.getUserTypeLabel(user.userType);
  }

  // Profile-panel subtitle: "Role · Organization", where role = title, else the
  // converted userType (same fallback as the members list / sliders).
  getProfileSubtitle(user: any): string {
    if (!user) { return ''; }
    const role = (user.title && String(user.title).trim()) || this.getUserTypeLabel(user.userType);
    const org = user.organisation && String(user.organisation).trim();
    return [role, org].filter(Boolean).join(' · ');
  }

  // Display labels for every userType the profile panel / members list can show.
  // The short forms for the first three are the wireframe wording and are kept
  // as-is. RECRUITER / JOB_SEEKER were previously unmapped and fell through to
  // the raw value, so a user with no title rendered as shouty "RECRUITER" /
  // "JOB SEEKER". Keep this table in sync with the copy in NewMessagePageComponent.
  private readonly userTypeLabelMap: { [key: string]: string } = {
    MANAGEMENT_TALENT_ACQUISITION: 'Manager',
    BENCH_RECRUITER: 'Bench Sales',
    FREELANCE_RECRUITER: 'Freelancer',
    RECRUITER: 'Recruiter',
    JOB_SEEKER: 'Job Seeker',
  };

  // Convert a raw userType to a display label. An unmapped type (admin roles, or
  // anything added server-side later) is title-cased rather than shown in caps.
  private getUserTypeLabel(userType: string): string {
    if (!userType) { return ''; }
    const key = String(userType).trim();
    if (!key) { return ''; }
    return this.userTypeLabelMap[key] || key.replace(/_/g, ' ').toLowerCase()
      .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }

}






